import { styled } from '@mui/material/styles';

import Base02Container from 'src/components/Base02Container';

export const Container = styled(Base02Container)(({ theme }) => ({
  color: theme.colors.base01,
}));

export const BodyContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',

  rowGap: '2.4rem',

  color: theme.colors.base01,
}));
